<template>
    <div class="relative">
        <input
            :value="modelValue"
            type="text"
            :placeholder="placeholder"
            data-testid="friend-search-input"
            class="border-stroke-1 bg-card w-full border p-3 pr-10 pl-10 text-white placeholder-gray-400 outline-none focus:border-red-500 focus:ring-2 focus:ring-red-500"
            @input="$emit('update:modelValue', $event.target.value)"
        />
        <div class="absolute top-1/2 left-3 -translate-y-1/2 transform">
            <svg
                class="h-4 w-4 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m21 21-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
                />
            </svg>
        </div>
        <button
            v-if="modelValue"
            @click="clearInput"
            class="absolute top-1/2 right-3 -translate-y-1/2 transform text-gray-400 transition-colors hover:text-white"
            type="button"
        >
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                />
            </svg>
        </button>
    </div>
</template>

<script>
export default {
    name: 'FriendSearchInput',
    props: {
        modelValue: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
    },
    emits: ['update:modelValue'],
    methods: {
        clearInput() {
            this.$emit('update:modelValue', '')
        },
    },
}
</script>
